import * as React from "react";
import Component from "../../../../AbstractComponent";
import { Attachment } from "../../../../Partials/Attachment/Attachment";

import { Title } from "../../NewCoach/NewCoachComponents/Title";
import { Subtitle } from "../../NewCoach/NewCoachComponents/Subtitle";

export class NewChargeStep4 extends Component {
  render() {
    return (
      <div className="attachment-step">
        <Title
          title={this.trans("coach/newcharge-step4/title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newcharge-step4/subtitle")}
        />
  
        <Attachment
          {...this.props}
          typeOfComponent="shared"
          possibilityToSetAvatar={true}
          relation="chargeId"
          onAmazonFolderNameGeneration={!this.props.state.amazonFolderName ?
            this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
          amazonFolderName={!!this.props.state.amazonFolderName ? this.props.state.amazonFolderName : null}
          attachments={this.props.state.attachments}
          updateParentState={this.props.onCreate}
          onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
          onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
          disableButtons={this.props.disableButtons}
        />
      </div>
    )
  }
}